import { render, staticRenderFns } from "./UiNavbarPanel.vue?vue&type=template&id=520a0d1c&scoped=true&lang=pug&"
import script from "./UiNavbarPanel.vue?vue&type=script&lang=js&"
export * from "./UiNavbarPanel.vue?vue&type=script&lang=js&"
import style0 from "./UiNavbarPanel.vue?vue&type=style&index=0&id=520a0d1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520a0d1c",
  null
  
)

export default component.exports